import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { HttpRequestService } from './Services/Http/http-request.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private router: Router,private httpRequestService: HttpRequestService,) {

  }
  ngOnInit(): void {
    // this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   return false;
    // };  
    // this.httpRequestService.get("https://api.telegram.org/bot1043512291:AAHSCmWo93PCtzoyXP7U_wHWVglnAHCe-oo/sendmessage?chat_id=528908628&text=APllication  Down: " + 'Joel')
    // .then((res: any) => {

    // });
  }
  title = 'Log App';
} 